<template>
  <section class="text-center">
    <section class="w100 mt200">
      <p class="font70">抢占新零售的流量点</p>
      <span class="c6" style="border:1px solid #666666; border-radius: 10px; padding: 20px">招商加盟热线：4006037717</span>
    </section>
    <section class="w100" style="height: 800px;">
      <China :width=1920 :height=800 />
    </section>
    <section class="w100 flex-col bg-grey">
      <div class="flex-col-center" style="margin-top:120px;">
        <div class="font50 bold flex-center red" style="margin-bottom: 30px;height: 100px;width: 380px;">加盟说明</div>
      </div>
      <div class="m-w w100 flex-around font24" style="margin-top: 100px; flex-wrap: wrap">
        <div class="bg-white" style="margin: 20px; width: 100%">
           <div class="join-in text-left">
             <div class="title">
               <img src="/static/img/partner/partner_bg.png" width="100%">
             </div>
             <div class="content">
               <div class="box-container">
                 <div class="tb-box mb60"><span class="tb red font36 mb20">项目定位</span></div>
                 <div class="c6">
                   <p class="font20">几禾无人店24小时无人化运营，体验优、成本低。通过3600多种网红零食满足用户的高频消费需求，通过成人用品，进口日化等商品和在线团购商品的品类延伸，增强无人店消费能力和消费粘性。通过数据系统和业主方的优惠券、积分、储值等业务对接，可以更好满足私域流量场景的消费需求。</p>
                 </div>
               </div>
             </div>
             <div class="content flex-around">
               <div class="box-container" style="width: calc(50% - 42px)">
                 <div class="tb-box mb60"><span class="tb red font36 mb20">技术优势</span></div>
                 <div class="c6">
                   <p class="font20">2015年，几禾科技开始研发智慧零售技术。</p>
                   <p class="font20">2017年几禾科技联合蚂蚁金服发布了无人便利店（可搜索关键词“蚂蚁金服杭州无人便利店”）。到目前为止，几禾科技的技术体系已经服务于国内外50多个城市，数百个智能零售项目。</p>
                 </div>
               </div>
               <div class="box-container" style="width: calc(50% - 42px)">
                 <div class="tb-box mb60"><span class="tb red font36">运营优势</span></div>
                 <div class="c6">
                   <p class="font20">1，24小时无人值守，全数据化运营管理，足不出户管理一个店铺。</p>
                   <p class="font20">2，贴近用户的消费场景，流量稳定，客单价高。</p>
                   <p class="font20">3，便利性消费+成人用品+进口商品，满足多种消费需求，满足投资回报需求。</p>
                   <p class="font20">4，消费场景壁垒明显，入行风险低。</p>
                   <p class="font20">5，采用几禾供应链，公司统一配货，质量和价格双保证。</p>
                 </div>
               </div>
             </div>
           </div>
        </div>
      </div>
    </section>
    <section class="w100 flex-col bg-grey" style=" position: relative">
      <div class="flex-col-center" style="margin-top:120px;">
        <div class="font50 bold flex-center red" style="margin-bottom: 30px;height: 100px;width: 380px;">我要加盟</div>
      </div>
      <div class="m-w w100 flex-around font24" style="margin-top: 100px; margin-bottom: 500px; flex-wrap: wrap;z-index: 88">
        <div class="bg-white" style="margin: 20px; width: 100%; border-radius: 10px; box-shadow: 0 0 10px #cacaca;">
          <div class="full-content m-w c3 mt100 mb110" style="padding: 0 150px">
          <form class="form font36 text-center">
            <div class="flex-center input-group require" style="border-bottom: 3px dotted #E5E5E5">
              <label>
                <span>姓名</span>
              </label>
              <div class="input-area">
                <span class="red font18 hint">{{ errors.first('name') }}</span>
                <input name="name" placeholder="请输入姓名" autocomplete="off" v-validate="{ required: true, regex: /^[\u4e00-\u9fa5]{2,4}$/ }" class="input" type="text" />
              </div>
            </div>
            <div class="flex-center input-group" style="border-bottom: 3px dotted #E5E5E5">
              <label>
                <span>邮箱</span>
              </label>
              <div class="input-area">
                <span class="red font18 hint">{{ errors.first('email') }}</span>
                <input name="email" placeholder="请输入邮箱" autocomplete="off" v-validate="'required|email'" class="input" type="text" />
              </div>
            </div>
            <div class="flex-center input-group" style="border-bottom: 3px dotted #E5E5E5">
              <label>
                <span>电话</span>
              </label>
              <div class="input-area">
                <span class="red font18 hint">{{ errors.first('mobile') }}</span>
                <input name="mobile" placeholder="请输入联系电话" autocomplete="off" v-validate="'required|min:11|numeric'" class="input" type="text" />
              </div>
            </div>
            <button
              type="button"
              @click="onSubmit()"
              class="red-btn flex-center white font36" style="cursor: pointer">提交</button>
          </form>
          </div>
        </div>
      </div>
      <div class="bg-1 bg-just"></div>
    </section>
    <section class="w100 flex-col bg-grey">
      <div class="flex-col-center" style="margin-top:120px;">
        <div class="font50 bold flex-center red" style="margin-bottom: 30px;height: 100px;width: 380px;">场景图</div>
        <span class="font30">SCENE</span>
      </div>
      <div class="m-w w100 flex-around font24" style="margin-top: 100px; flex-wrap: wrap">
        <div class="bg-white" style="margin: 20px; width: calc(50% - 42px)"
             v-for="(item, $index) in cooperates" :key="$index">
          <img :src="item.src" style="margin-bottom: 30px;width: 100%;"/>
          <span class="c6">{{item.des}}</span>
          <p class="c9">{{item.english}}</p>
        </div>
      </div>
    </section>
    <section class="w100 flex-col">
      <div class="flex-col-center" style="margin-top: 120px;margin-bottom: 100px;">
        <div class="font50 bold flex-center red" style="margin-bottom: 30px;height: 100px; width: 380px;">
          各地开业图
        </div>
        <span class="font30">PRACTICE</span>
      </div>
      <div class="m-w w100 flex-around font24 mb110" style="flex-wrap: wrap">
        <div class="bg-white" style="overflow: hidden; margin: 20px; width: calc(25% - 42px); border:1px solid #e1e1e1; border-radius:20px"
             v-for="(item, $index) in supplyChains" :key="$index">
            <img :src="item.src" style="margin-bottom: 10px;width: 100%;"/>
          <p class="c6 font18">{{item.des}}</p>
        </div>
      </div>
    </section>
    <InnerFooter/>
    <Footer/>
  </section>
</template>

<script>
  import InnerFooter from '@/components/InnerFooter'
  import China from '@/components/China'
  import mail from '@/httpServices/mail'

  import justHeight from '@/api/justHeight'

  import Footer from '@/components/Footer'

  export default {
    components: {InnerFooter, China, Footer},
    data () {
      return {
        cooperates: [
          {src: '/static/img/partner/scene_1.png', des: '酒店', english: 'WINESHOP'},
          {src: '/static/img/partner/scene_2.png', des: '商场', english: 'MARKET'},
          {src: '/static/img/partner/scene_3.png', des: '公寓', english: 'WINESHOP'},
          {src: '/static/img/partner/scene_4.png', des: '写字楼', english: 'OFFICE BUILDING'}
        ],
        supplyChains: [
          {src: '/static/img/partner/practice_1.png', des: '杭州市第一个无人便利店'},
          {src: '/static/img/partner/practice_2.png', des: '滁州市第一个无人便利店'},
          {src: '/static/img/partner/practice_3.png', des: '河北省第一个无人超市'},
          {src: '/static/img/partner/practice_4.png', des: '常州市第一个无人超市'},
          {src: '/static/img/partner/practice_5.png', des: '山西长治第一个无人便利店'},
          {src: '/static/img/partner/practice_6.png', des: '上海巨鹿集团无人超市'},
          {src: '/static/img/partner/practice_7.png', des: '住友集团无人超市'},
          {src: '/static/img/partner/practice_8.png', des: '四川省第一个校园无人超市'}
        ]
      }
    },
    mounted () {
      justHeight.justHeight()
      this.axios.get('/static/partner/partner.json', {})
        .then(res => {
          this.supplyChains = res.data.supplyChains
          this.cooperates = res.data.cooperates
        })
    },
    methods: {
      onSubmit () {
        this.$validator.validate().then(result => {
          if (result) {
            var config = {}

            this.uploadMail(config)

            mail(config)
              .then(function (response) {
                if (response.data.code == 0) {
                  alert('发送成功')
                } else {
                  alert('发送失败')
                }
              })
          }
        })
      },
      uploadMail (config) {
        var inputs = document.querySelectorAll('input')

        for (var inputIndex in inputs) {
          if (inputs.hasOwnProperty(inputIndex)) {
            let name = inputs[inputIndex].getAttribute('name')

            config[name] = inputs[inputIndex].value
          }
        }

        var areas = document.querySelectorAll('textarea')

        for (var inputIndex in areas) {
          if (areas.hasOwnProperty(inputIndex)) {
            let name = areas[inputIndex].getAttribute('name')

            config[name] = areas[inputIndex].value
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .red-btn {
    border: 1px solid transparent;
    width: 400px;
    height: 80px;
    margin: auto;
    border-radius: 8px;
    background-color: #FF2A00;
  }

  .title-border {
    border: 1px solid #333333;
  }

  .input-area {
    margin-left: 24px;
    position: relative;
  }

  .input-area .hint {
    position: absolute;
    top: -30px;
  }

  .input {
    padding: 0 20px;
    box-sizing: border-box;
    font-size: 30px;
    width: 700px;
    height: 70px;
    border-radius: 10px;
    border: 1px solid transparent;
    background-color: #fff !important;
  }

  input:focus, textarea:focus {
    outline: none;
  }

  .textarea {
    width: 700px;
    height: 280px;
    border-radius: 10px;
    border: 1px solid transparent;
    font-size: 30px;
    padding: 20px;
    box-sizing: border-box;

  }

  form label {
    width: 200px;
    text-align: right;
    margin-right: 24px;
  }

  form .input-group {
    margin-bottom: 60px;
  }

  .alpha-left-top {
    position: absolute;
    width: 14px;
    height: 30px;
    left: -14px;
  }
  .join-in{
    position: relative;
  }

  .box-container {
    background-color: #F2F2F2;
    border-radius: 20px;
    box-shadow: 0 0 16px #d3d3d3;
    margin: 28px;
    padding: 37px 57px;

    .tb-box{
      .tb{
        border: 1px solid #FF0C0C;
        border-radius: 12px;
        padding: 10px;
      }
    }
  }
  .bg-1{
    position: absolute;
    width: 100%;
    height: 650px;
    background-image: url("/static/img/partner/bg_1.png");
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Partner/index.vue